import styled from 'styled-components';

import colors from '../../../../../styles/colors';

export const CardContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  background: ${colors.$background_primary};
  border-radius: 8px;
  margin-bottom: 16px;
  padding-left: 0px;
  padding-right: 0px;
  padding-top: 0px;
  padding-bottom: 0px;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    column-gap: 16px;
    background: ${colors.$background_primary};
    border-radius: 8px;
    margin-bottom: 16px;
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 0px;
    padding-bottom: 0px;
  }
`;

export const ProgressContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 8px;
`;

export const LeftLabel = styled.p`
  font-weight: 700;
  font-size: 20px;
  line-height: 22px;
  margin: 0 !important;
  margin-right: 8px !important;
`;

export const CampoLoteExtraStyle = {
  width: '85%',
  whiteSpace: 'none',
  overflow: '',
};

export const CampoLoteLabelExtraStyle = {
  fontWeight: 500,
  fontSize: '18px',
  lineHeight: '24px',
};
